/* src/app/shared/components/ag-divider/ag-divider.component.scss */
.horisontal-wrapper {
  height: fit-content;
  display: flex;
  align-items: center;
}
.horisontal-wrapper .or-line {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.horisontal-wrapper .or-line h4 {
  color: #5c5c5c;
}
.vertical-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vertical-wrapper .line-vertical {
  width: 1px;
}
/*# sourceMappingURL=ag-divider.component.css.map */
